import { render, staticRenderFns } from "./ListaVenta.vue?vue&type=template&id=82a52ece&scoped=true"
import script from "./ListaVenta.vue?vue&type=script&lang=js"
export * from "./ListaVenta.vue?vue&type=script&lang=js"
import style0 from "./ListaVenta.vue?vue&type=style&index=0&id=82a52ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a52ece",
  null
  
)

export default component.exports